module.exports = __webpack_public_path__ + "img/toslogo.a05d767a.png";